<template v-slot:combobox>
	<v-combobox
			v-model="model"
			:items="locationList"
			:search-input.sync="search"
			label="Location"
			required
			class="required"
			:attach="'#'+id"
			return-object
			placeholder="City, State, ZIP"
			@focus="setPosition"
			@blur="leaveAction"
			@input="menuAct = true"
			@change="check($event)"
			:loading="loading"
			:readonly="permissionsReed"
			:menu-props="{ minWidth: 280, offsetOverflow: true, bottom: true, }"
	>
		<template v-if="!idComponent" v-slot:append-outer>
			<div class="list-holder" :id="id"></div>
		</template>
	</v-combobox>
</template>
<script>
import { mapGetters } from "vuex";

export default {
	props: [ "data-location", "readonly-flag", "id-component", "id-attach", "permissions" ],
	data: () => ({
		descriptionLimit: 60,
		entries: [],
		isLoading: false,
		model: "",
		search: "",
		location: [],
		locationList: [],
		loading: false,
		first: true,
		locEmit: null,
		el: null,
	}),

	computed: {
		...mapGetters([ 'role' ]),
		permissionsReed() {
			if (this.readonyFlag) return true;
			else if (this.permissions['59']) return false;
			return false;
		},
		items() {
			return this.entries;
		},
		id() {
			if (this.idComponent) return "list-container";
			return "a" + this.generateNum();
		}
	},
	mounted() {
		this.$store.watch(
			(store, getters) => getters.getScrollPosition,
			(newVal) => {
				if (newVal === false) {
					if (this.el) {
						this.$children[0].blur();
						this.$store.dispatch("setScrollPosition", false);
					}
				}
			}
		);
		if (this.dataLocation.loction.city != null) {
			this.model =
					(this.dataLocation.loction.city ? this.dataLocation.loction.city : '') +
					(this.dataLocation.loction.state ? ", " + this.dataLocation.loction.state : '') +
					(this.dataLocation.loction.zip_code ? ", " + this.dataLocation.loction.zip_code : '');
			this.locEmit = this.model;
		}
	},
	methods: {
		generateNum() {
			return Math.round((Math.random() * (1945 - 20)) + 10);
		},
		check(e) {
			this.locEmit = e;
			this.model = e;
		},
		leaveAction() {
			this.menuAct = false;
			if (this.model !== this.locEmit || this.search !== this.locEmit) {
				this.model = "";
				this.search = "";
				this.locEmit = null;
			} else {
				this.actionActive();
			}
		},
		activeWatchPos() {
			this.$store.dispatch("setScrollPosition", null);
		},
		actionActive() {
			const valArr = this.model.split(", ");
			const valObj = {
				city: valArr[0],
				state: valArr[1],
				zip_code: valArr[2],
			};
			const res = this.location.find((item) => {
				const result = [];
				for (const i in valObj) {
					if (valObj[i] == item[i]) {
						result.push(true);
					}
				}
				if (result.length >= 2) {
					return true;
				}
				return false;

			});
			Object.assign(this.dataLocation.loction, res);
			this.$emit("edit-day");
		},
		setPosition(e) {
			this.activeWatchPos();
			this.el = e.target;
			if (this.idComponent) {
				const target = e.target;
				const params = target.getBoundingClientRect();
				const position = {
					left: params.x,
					top: params.y,
				};
				this.$store.dispatch("setPosition", position);
			}
		},
		async querySelections(v) {
			this.loading = true;
			let valObj = [];
			if (v) {
				valObj = v.split(", ").filter((value) => value.trim().length);
			}
			try {
				if (valObj.length == 1) {
					this.location = await this.$store.dispatch("getLocation", { string: valObj[0] });
				} else if (valObj.length == 2) {
					this.location = await this.$store.dispatch("getLocation", { string: valObj[0] });
				} else if (valObj.length == 3) {
					this.location = await this.$store.dispatch("getLocation", { string: valObj[2] });
				} else if (valObj.length > 3) {
					this.location = await this.$store.dispatch("getLocation", { string: valObj[0] });
				}

				this.$emit('back-data', this.location[0]);
				this.locationList = [];
				for (let i = 0; i < this.location.length; i++) {
					const str =
							this.location[i].city +
							", " +
							this.location[i].state +
							", " +
							this.location[i].zip_code;
					this.locationList.push(str);
				}
				this.loading = false;
			} catch (error) {
				this.loading = false;
				console.error(error);
			}
		},
	},
	watch: {
		locationList(arr) {
			this.$emit('locatArr', arr);
		},
		search(val) {
			this.querySelections(val);
		},
	},
};
</script>
<style lang="scss" scoped>
.list-holder {
	position: absolute;
	left: 0;
	top: 0;
	margin-top: -10px;
}
</style>
